import React from "react";
import { Phone } from "lucide-react";
import { BUSINESS } from "../lib/constants";

export default function StickyCall() {
  return (
    <a
      href={`tel:${BUSINESS.phoneRaw}`}
      data-testid="sticky-call-button"
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 inline-flex items-center justify-center gap-2 bg-[#F5A623] text-[#14110F] px-6 py-4 rounded-full text-sm font-bold uppercase tracking-[0.15em] shadow-[0_20px_40px_-12px_rgba(245,166,35,0.5)]"
    >
      <Phone className="w-4 h-4" />
      Call {BUSINESS.phone}
    </a>
  );
}
